/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { UserCallCenterUpdateInput } from '../../models/user-call-center-update-input';

export interface UsersUserIdCallCentersPut$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
      body: UserCallCenterUpdateInput
}

export function usersUserIdCallCentersPut(http: HttpClient, rootUrl: string, params: UsersUserIdCallCentersPut$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
  const rb = new RequestBuilder(rootUrl, usersUserIdCallCentersPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      }>;
    })
  );
}

usersUserIdCallCentersPut.PATH = '/users/{userId}/call-centers';
